type Procedure = (...args: unknown[]) => void;

export const debounce = <T extends Procedure>(func: T, wait: number): ((...args: Parameters<T>) => void) => {
    let timeout: number;
    return (...args: Parameters<T>): void => {
        clearTimeout(timeout);
        timeout = window.setTimeout(() => func(...args), wait);
    };
};
